'use strict';

var AbstractFormView = require('components/common/views/abstract_form_view');
var App = require('app');
var Consts = require('consts');
var Decorator = require('utils/decoration');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');
var MultiInput = require('components/common/views/multi_input_view');
var Notification = require('utils/notification');
var OOP = require('utils/oop');

var ConfigureUserDialogView = OOP.extend(
    AbstractFormView,
    {
        template: require('components/common/templates/configure_user_dialog'),

        events: function () {
            return _.extend({}, AbstractFormView.prototype.events, {
                'click div.js-perm-preset': 'setPresetPermissions',
                'click div.js-perm-set': 'setPermission',
                'click button#js-save': 'validateForm',
            });
        },

        regions: {
            emailInput: '#js-email-region',
        },

        childEvents: {
            destroy: function () {
                this.items = this.emailInputView.getItems();
            },
        },

        initialize: function (options) {
            this.options = options;
            this.controller = options.controller;
            this.permissionsCtrl = Misc.initPermissionsControl('perm');
            this.permissionsCtrl.setDevices(options.devices);
            this.permissionsCtrl.setBasePermissions(options.permission_base.get('access_rights'));

            this.items = [];
            this.errors = {};
            if (options.model) {
                this.permissionsCtrl.setSelected(options.model.get('access_rights'));
            } else {
                this.permissionsCtrl.setSelected(this.permissionsCtrl.getAllPermissions());
            }

            var self = this;
            return this.base.initialize({
                formData: options.model ? options.model.toJSON() : {},
                inputFields: {
                    'js-email': {
                        method: 'callback',
                        validIfNotVisible: true,
                        validationCB: function () {
                            return self.emailInputView.validate();
                        },
                        flashThis: function () {
                            return $('#js-email-input').siblings('.bootstrap-tagsinput');
                        },
                    },
                },
            });
        },

        serializeData: function () {
            var data = AbstractFormView.prototype.serializeData.apply(this, arguments);
            data.permissionsData = this.permissionsCtrl.getSerializedData();
            data.hasAnyPermission = _.keys(this.permissionsCtrl.getSelected()).length > 0;
            // single device? -> set user-defined circuit names
            if (this.options.devices.length === 1) {
                _.forEach(this.options.devices[0].getCircuitNames(), function (val, key) {
                    var permID = _.invert(Consts.PermissionsToRoute)[key];
                    var idx = _.findIndex(data.permissionsData.permissions, { id: permID });
                    if (idx !== -1) {
                        data.permissionsData.permissions[idx].userDefName = val;
                    }
                });
            }
            return data;
        },

        validateForm: function (e) {
            e.preventDefault();
            var self = this;

            if (this.allFieldsValid()) {
                var form = Backbone.Syphon.serialize(this);

                Decorator.disableElement('.modal-dialog');
                this.options.update_user_cb({
                    model: this.model,
                    permissions: this.permissionsCtrl.getSelected(),
                    emails: this.emailInputView ? this.emailInputView.getItems() : [],
                    success: function (errors) {
                        App.hideModal();
                        if (self.model === undefined) {
                            Notification.show(
                                'success',
                                i18n.TR('Erfolg'),
                                i18n.TR('E-Mail zur Bestätigung der Gerätefreigabe wurde versendet.')
                            );
                        }
                    },
                    error: function (errors) {
                        // exactly one user in request which already has permissions? -> show error
                        // else (hacker/multiple users already have permissions) -> just close
                        if (
                            errors.status === 400 &&
                            (!errors.responseJSON || self.emailInputView.getItems().length > 1)
                        ) {
                            App.hideModal();

                            Notification.show(
                                'warning',
                                i18n.TR('Erfolg'),
                                i18n.TR('Einige Nutzer haben bereits Zugriff auf das Gerät.')
                            );
                            return;
                        }
                        self.showErrors(errors);
                    },
                });
            }
        },

        showErrors: function (errors, form) {
            this.errors = errors;
            this.formData = form;
            App.refreshModal(this);
        },

        initPermControl: function () {
            var self = this;
            this.permissionsCtrl.initEvents(function () {
                self.formData = Backbone.Syphon.serialize(self);
                self.render();
            });
        },

        onShow: function () {
            this.initPermControl();
        },

        render: function () {
            this.base.render();
            this.initPermControl();
            if (this.model) {
                return;
            }
            this.initMultiInput();
            this.showChildView('emailInput', this.emailInputView);
        },

        initMultiInput: function () {
            this.emailInputView = new MultiInput.GetMultiEmailView({
                items: this.items,
                response: this.errors,
                error500Text: i18n.TR('Die Vergabe der Geräterechte ist fehlgeschlagen.'),
                error400Text: i18n.TR('Dieser Nutzer hat bereits Zugriff.'),
            });
        },
    },
    'ConfigureUserDialogView'
);

module.exports = ConfigureUserDialogView;
